var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5625 6L11.6875 2.875C12.0938 2.5 12.0938 1.875 11.6875 1.5L11 0.8125C10.625 0.40625 10 0.40625 9.625 0.8125L6.5 3.9375L3.34375 0.8125C2.96875 0.40625 2.34375 0.40625 1.96875 0.8125L1.28125 1.5C0.875 1.875 0.875 2.5 1.28125 2.875L4.40625 6L1.28125 9.15625C0.875 9.53125 0.875 10.1562 1.28125 10.5312L1.96875 11.2188C2.34375 11.625 2.96875 11.625 3.34375 11.2188L6.5 8.09375L9.625 11.2188C10 11.625 10.625 11.625 11 11.2188L11.6875 10.5312C12.0938 10.1562 12.0938 9.53125 11.6875 9.15625L8.5625 6Z",
    fill: "#27509F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.c5dcb38659912060ef9f60bff0d846f3.svg";
export { ForwardRef as ReactComponent };